<header
  [style]="styles().headerBasic"
  [class.is-sticky]="isSticky"
  data-testid="header"
>
  <div class="container">
    @if (logoDisplay() && logoSrc() && logoSrc().urls && logoSrc().urls[ImageSizes.Thumbnail]) {
      <div
        class="logo"
        data-testid="logo"
        [ngStyle]="styles()"
      >
        @if (logoRedirect()) {
          <a [href]="logoRedirect()">
            <ng-container [ngTemplateOutlet]="logo"></ng-container>
          </a>
        } @else {
          <a [routerLink]="['']" aria-label="Go to homepage">
            <ng-container [ngTemplateOutlet]="logo"></ng-container>
          </a>
        }
      </div>
    }
    <ng-container [ngTemplateOutlet]="navMenu"></ng-container>
    <div class="site-actions">
      <app-icon-button
        icon-btn-small
        icon-btn-icon-large
        icon-btn-primary
        class="search-button"
        data-testid="search-button"
        [routerLink]="[RoutePaths.Search]"
        (click)="onSearchButtonClick()"
        matIcon="search_icon"
        ariaLabel="Search"
        i18n-ariaLabel="@@header.search-button.aria-label"
      />
      @if (checkIncludeLanguageSelect()) {
        <app-language-select
          [languages]="this.globalDataService.loadedLanguages()"
          [selected]="this.globalDataService.selectedLanguage().code"
          data-testid="app-language-select"
        />
      }
    </div>
    <app-currency
      [options]="globalDataService.loadedCurrencies()"
      [selectedOption]="globalDataService.selectedCurrency()"
      (selectCurrency)="eventService.notifyCurrencySelected($event)"
      data-testid="app-currency"
    />
    <app-icon-button
      icon-btn-small
      icon-btn-icon-large
      icon-btn-primary
      class="menu-toggle"
      data-testid="menu-toggle"
      (click)="toggleNavMenu()"
      [disabled]="navMenuIsOpen"
      matIcon="menu"
      ariaLabel="Mobile menu"
      i18n-ariaLabel="@@header.mobile-menu-button.aria-label"
    />
  </div>
</header>

<div
  class="backdrop"
  (click)="toggleNavMenu()"
  data-testid="backdrop"
  [class.open]="navMenuIsOpen"
></div>
<section
  class="mobile-menu"
  [class.open]="navMenuIsOpen"
  data-testid="mobile-menu"
>
  <div class="mobile-menu__title" data-testid="menu-title">
    <div
      i18n="@@header.menu-title"
      class="mobile-menu__title-text"
    >Menu</div>
    <app-icon-button
      icon-btn-small
      icon-btn-icon-large
      (click)="toggleNavMenu()"
      matIcon="close_icon"
      data-testid="close-button"
    />
  </div>
  <div class="mobile-menu__content">
    <ng-container [ngTemplateOutlet]="navMenu"></ng-container>
    @if (checkIncludeLanguageSelect()) {
      <app-language-select
        [languages]="this.globalDataService.loadedLanguages()"
        [selected]="this.globalDataService.selectedLanguage().code"
        [style]="'dropdown'"
        data-testid="app-language-select"
      />
    }
    <app-currency
      [options]="globalDataService.loadedCurrencies()"
      [selectedOption]="globalDataService.selectedCurrency()"
      (selectCurrency)="eventService.notifyCurrencySelected($event)"
      data-testid="app-currency"
    />
  </div>
  <div class="mobile-menu__footer">
    <app-button
      i18n="@@header.mobile-search-button.label"
      data-testid="search-button"
      btn-large
      btn-contained
      [routerLink]="[RoutePaths.Search]"
      (click)="loadAndFocusSearch();"
    >Search equipment</app-button>
  </div>
</section>

<ng-template #logo>
  <img
    [src]="logoSrc().urls[ImageSizes.Thumbnail]"
    aria-hidden="true"
    alt="company logo"
    i18n-alt="@@header.logo.alt-text"
  />
</ng-template>

<ng-template #navMenu>
  <ul class="nav-menu">
    @for (item of menuItems(); track item) {
      <li>
        @let i18nLabel = i18n.get(item.label);
        @switch (item.type) {
          @case ('internal') {
            <app-button
              btn-large
              btn-text
              [routerLink]="[item.routerLink ?? '/']"
              (click)="onInternalLinkClick(item)"
              data-testid="internal-menu-item"
            >{{i18nLabel}}</app-button>
          }
          @case ('external') {
            <app-button
              btn-large
              btn-text
              [href]="item.href"
              (click)="onExternalLinkClick(item)"
              [target]="getExternalLinkTarget()"
              data-testid="external-menu-item"
            >{{i18nLabel}}</app-button>
          }
          @case ('contact') {
            <app-button
              btn-large
              btn-text
              (click)="onContactClick($event, item)"
              data-testid="contact-menu-item"
            >{{i18nLabel}}</app-button>
          }
          @case ('finance') {
            @if (financeService.validateSettings()) {
              <app-button
                btn-large
                btn-text
                (click)="onFinanceClick($event, item)"
                data-testid="finance-menu-item"
              >{{i18nLabel}}</app-button>
            }
          }
        }
      </li>
    }
  </ul>
</ng-template>

<ng-template #siteActions>
  
</ng-template>
